import { Box } from '@mui/material';
import HeaderNotifications from './Notifications';
import LanguageSwitcher from './LanguageSwitcher';

export default function HeaderButtons() {
  return (
    <Box>
      {
        process.env.NODE_ENV === 'development' && <HeaderNotifications />
      }
      <LanguageSwitcher />
    </Box>
  );
}
